import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { PointCardCodeTemplate } from 'components/Templates'

const PointCardCode: FC = () => {
  return (
    <Layout iconPath={'/icon/white/point_card.svg'} headline={'ポイント付与QRコード'} title={'ポイント付与QRコード'}>
      <PointCardCodeTemplate />
    </Layout>
  )
}

export default PointCardCode
